<template>
    <el-container direction="vertical" style="align-items:center;background-color:#e1e1e1;position:relative">
      <div class="province-tip">
        <el-card>
          <div v-for="(item, index) in counter.provinceCount" :key="index">
            {{item['_id']}}: {{item.pc}}
          </div>
        </el-card>
      </div>

      <div class="work-tip">
        <el-card>
          <div>
            <span>作品总数： {{counter.totalCount}}</span>
          </div>
          <div>
            <span>已阅数量： {{counter.judgedCount}}</span>
          </div>
          <div>
            <span>优秀作品： {{counter.excellentCount}}</span>
          </div>
          <div>
            <span>典型错误： {{counter.lowCount}}</span>
          </div>
        </el-card>
      </div>

      <div class="work-viewer">
        <div class="work-title">
          <span>{{work.title}} （{{work.type}}）{{work.province}}</span>
          <div class="icons">
            <el-button type="primary" icon="el-icon-sunny" size="small" circle :plain="!work.excellent" @click="markWork('excellent')"></el-button>
            <el-button type="danger" icon="el-icon-lightning" size="small" circle :plain="!work.low" @click="markWork('low')"></el-button>
          </div>
        </div>

        <div class="work-body" v-html="work.content"></div>

        <div class="work-footer">
          <el-button type="primary" plain @click="previousWork" @keyup="previousWork">上一篇</el-button>
          <div>
            <el-input v-model="work.score" placeholder="请输入分数" style="width: 100px;" @keyup.native.13="saveScore"></el-input>
            <span style="margin-left:20px;color:#999;font-size:14px;">字数：{{work.wordCount}}</span>
          </div>
          <el-button type="primary" @click="nextWork" plain>下一篇</el-button>
        </div>
      </div>

    </el-container>
</template>

<script>
let that
export default {
  data(){
    return {
      work: {
        score:''
      },
      counter:{
        totalCount:0,
        judgedCount:0,
        excellentCount:0,
        lowCount:0
      },
      viewHistory: [],
      historyIndex: -1

    }
  },
  methods:{
    // 上一篇
    previousWork(){
      if(this.historyIndex == 0){
        that.$notify({
          title: '提示',
          message: '没有上一篇了',
          type: 'warning',
          duration: 2000
        })
      }else{
        this.historyIndex--
        this.work = this.viewHistory[this.historyIndex]
      }
    },

    // 下一篇
    nextWork() {
      if(this.historyIndex == this.viewHistory.length - 1){
        this.loadWork()
      }else {
        this.historyIndex++
        this.work = this.viewHistory[this.historyIndex]
      }
    },

    // 保存分数
    saveScore(){
      if(this.work.score){
        try {
          this.work.score = parseInt(this.work.score)
          this.api.works.saveWork(this.work).then(res => {
            let data =res.data
            if(typeof(data) === 'string'){
              that.$notify({
                title: '提示',
                message: data,
                type: 'error'
              });
            }else{
              if(that.historyIndex == this.viewHistory.length - 1){
                that.loadWork()
              }else{
                that.historyIndex++
                that.work = that.viewHistory[that.historyIndex]
              }
            }
          })
        } catch (error) {
          that.$notify({
            title: '提示',
            message: '得分必须为整数',
            type: 'error',
            duration: 2000
          });
        }
      }else {
        that.$notify({
          title: '提示',
          message: '请输入得分',
          type: 'error',
          duration: 2000
        });
      }
    },

    // 加载作品
    loadWork() {
      let manager = JSON.parse(sessionStorage.getItem("manager"))
      this.api.works.getWorkByJid(`jid=${manager.id}`).then(res => {
        let data = res.data
        if(typeof(res.data) === 'string'){
          that.$notify({
            title: '提示',
            message: data,
            type: 'warning'
          });
        }else {
          that.work = data
          console.log(data)
          if(that.viewHistory.length > 0 && that.viewHistory[that.historyIndex].id == data.id) {
            return
          }
          that.viewHistory.push(data)
          that.historyIndex++
          that.loadCounter()
        }
      })
    },

    // 加载计数器
    loadCounter() {
      let manager = JSON.parse(sessionStorage.getItem("manager"))
      this.api.works.getJudgeCounter(`jid=${manager.id}`).then(res => {
        that.counter = res.data
      })
    },

    // 标记作品
    markWork(flag){
      if(this.work[flag]){
        this.work[flag] = 0
      }else{
        this.work[flag] = 1
      }
      this.api.works.saveWork(this.work).then(res => {
        let data =res.data
        if(typeof(data) === 'string'){
          that.$notify({
            title: '提示',
            message: "操作失败！",
            type: 'error'
          });
        }else{
          let msg = "操作成功，此作品"
          msg += this.work[flag] ? '已标记为': '已取消标记为'
          msg += flag == 'excellent' ? '优秀作品': '典型错误作品'
          that.$notify({
            title: '提示',
            message: msg,
            type: 'success',
            duration: 3000
          });
          that.loadCounter()
        }
      })
    }
  },
  mounted() {
    that = this
    this.loadWork()
    // 键盘操作事件
    let code1 = 0
    document.onkeydown = function() {
      let key = window.event.keyCode;
      console.log(key)
      if(key == 18){
        code1 = 1
      }
      
      if(code1 && key == 37) {
        that.previousWork()
      }

      if(code1 && key == 39) {
        that.nextWork()
      }

    }
    document.onkeyup = function() {
      let key = window.event.keyCode;
      if(key ==18){
        code1 = 0
      }
      
    }

  }
}
</script>


<style>
.work-tip{
  position: absolute;
  right: 20px;
  top: 20px;
}

.province-tip{
  position: absolute;
  left: 20px;
  top: 20px;
}

.work-tip div{
  color: #888;
  margin-top: 5px;
}

.province-tip div{
  color: #888;
  margin-top: 5px;
}

.work-viewer{
  flex: 1;
  width: 760px;
  margin: 10px;
  border: 1px solid #ccc;
  background-color: #fff;
  border-radius: 4px;
  display: flex;
  flex-flow: column;
  height: 0;
}

.work-title{
  height: 50px;
  line-height: 50px;
  background:#f6f6f6;
  color: #666;
  text-align: center;
  border-radius: 4px;
  border-bottom: 1px solid #eee;
  position: relative;
}

.work-title .icons{
  position: absolute;
  right: 20px;
  top: 0px;
  display: inline;
}

.work-body{
  flex: 1;
  overflow: auto;
  color:#555;
  padding: 10px 20px;
  line-height: 28px;
}

.work-body p{
  margin-top: 20px;
}


.work-footer{
  height: 50px;
  border-top: 1px solid #eee;
  background:#f6f6f6;
  border-radius: 4px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>

